import { UserCard } from "@/components/cards";
import { useAuth } from "@/hooks/use-auth";
import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";

export function AttendancesHeader() {
	/** Hooks */
	const { t } = useTranslation();
	const { user } = useAuth();

	/** Render */
	return (
		<ContentCard
			title={t("users.my_attendances")}
			icon={icon("Timer")}
		>
			<UserCard
				userId={user?.id}
				variant="plain"
			/>
		</ContentCard>
	);
}
